import { gql, useMutation } from '@apollo/client';
import type {
  UpdateUserEmailMutation,
  UpdateUserEmailMutationVariables,
} from '../graphql/generated/graphqlTypes';

const UPDATE_EMAIL_MUTATION = gql`
  mutation updateUserEmail($id: ID!, $email: String!) {
    updateUser(id: $id, email: $email) {
      id
      email
    }
  }
`;

const useUpdateEmailMutation = () => {
  const [mutate] = useMutation<
    UpdateUserEmailMutation,
    UpdateUserEmailMutationVariables
  >(UPDATE_EMAIL_MUTATION);

  return (id: string, email: string) => mutate({ variables: { id, email } });
};

export default useUpdateEmailMutation;
